import { noop } from 'lodash';
import { createContext } from 'react';

import { Announce } from './Announcer';

export interface AnnouncerContextProps {
  readonly announce: Announce;
}

const AnnouncerContext = createContext<AnnouncerContextProps>({
  announce: noop,
});

export default AnnouncerContext;
